import { render, staticRenderFns } from "./SuccessAssessment.vue?vue&type=template&id=9f9927c4&scoped=true"
import script from "./SuccessAssessment.vue?vue&type=script&lang=js"
export * from "./SuccessAssessment.vue?vue&type=script&lang=js"
import style0 from "./SuccessAssessment.vue?vue&type=style&index=0&id=9f9927c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9927c4",
  null
  
)

export default component.exports